import type { FileUpload } from '~kui/components/KUI/Core/File/Upload/types';

import type { FragmentType } from '~/graphql/generated/fragment-masking';

import { adminContentFileFragment } from '~/graphql/documents/content';
import { publicFileFragment } from '~/graphql/documents/core';
import { useFragment } from '~/graphql/generated/fragment-masking';

export const transformPublicFile = (data: FragmentType<typeof publicFileFragment> | null | undefined): FileUpload | null => {
  const { mapPublicFragmentToUpload } = useV2CoreFileUpload();
  if (!data) {
    return null;
  }

  const unmaskedData = useFragment(publicFileFragment, data);
  return mapPublicFragmentToUpload(unmaskedData);
};

export const transformAdminContentFile = (data: FragmentType<typeof adminContentFileFragment> | null | undefined): FileUpload | null => {
  const { mapPublicFragmentToUpload } = useV2CoreFileUpload();
  if (!data) {
    return null;
  }

  const unmaskedData = useFragment(adminContentFileFragment, data);
  return mapPublicFragmentToUpload(unmaskedData);
};
